<template>
  <div class="video-background" :class="{ 'ready' : ready }" id="video-background"></div>
</template>

<script>

import Vimeo from "@vimeo/player";

export default {

  data(){
    return {
      src: '',
      vQuality: '540p',
      ready: false,
      player: null
    }
  },

  props: {
    url: { type: String, default: '' },
    img: { type : String, default: ''}
  },

  mounted(){
    let vm = this;

    if ( vm.type === 'vimeo' ) {

      let options = {
        "url" : vm.url,
        "controls" : false,
        "loop" : true,
        "quality" : vm.vQuality,
        "muted" : true
      }

      let player = new Vimeo('video-background', options);
      vm.player = player;

      player.on('loaded', () => {
        vm.ready = true;
        setTimeout(()=> { player.play() }, 300)
      })

      Event.listen('video-background-pause', vm.pause);
      Event.listen('video-background-play', vm.play);

    } else if( vm.type === 'youtube' ) {
      let vb = document.getElementById('video-background');
      let i = document.createElement("iframe");
      i.src = 'https://www.youtube.com/embed/' + vm.videoid + '?rel=0&modestbranding=1&controls=0&autoplay=1&vq=medium'
      vb.appendChild(i);
      vm.ready = true;
    }
  },

  computed: {
    type(){
      if( this.url.includes('youtu') ){
        return 'youtube';
      } else if( this.url.includes('vimeo') ){
        return 'vimeo';
      }
    },
    videoid(){
      let url = this.url;
      if(url.includes('youtube')){
        return url.substring(url.lastIndexOf('?v=')+3);
      } else if(url.includes('youtu.be')){
        return url.substring(url.lastIndexOf('/')+1);
      } else if(url.includes('vimeo')){
        return url.substring(url.lastIndexOf('com/')+4);
      }
    }
  },

  methods: {
    pause() {
      this.player.pause()
    },
    play() {
      this.player.play()
    }
  }
}

</script>